<template>
    <div>
    </div>
</template>


<script>
import postscribe from 'postscribe';
import $ from 'jquery'

export default {
    name: 'SFHeader',
    data(){
        return {
            /* sf_comics: [
                {
                    name: "O Sarilho",
                    link: "https://sarilho.net/en/",
                    bannerLink: ""
                },
                {
                    name: "Fate",
                    link: "https://www.fatecomic.com/",
                    bannerLink: "https://spiderforest.com/wp-content/uploads/2020/08/SF-Wide_Banner_Fate_fixed.jpg"
                },
            ],
            cur_banner: 0,
            display_list: false, */
            banner_added: false,
        }
    },
    mounted(){
        /*eslint-disable*/
        if(!this.banner_added){
            //console.log("Loading SFBanner!")
            postscribe(document.body,'<script type="text/javascript" src="https://network.spiderforest.com/header.php?net=SF&id=ktwc&g=false&bg=000000&attach=body&type=dev2%22%3E"><\/script>',{
                done: function(){
                $(".sfheader").prependTo(document.body)
                document.querySelector(".sfdrop").style.color="white";
                //console.log("Loaded SFBanner!")
                this.banner_added = true;
                }
            })
        }
        /*eslint-disable*/
    },
    /* created(){
        this.cur_banner = Math.floor(Math.random() * this.sf_comics.length);
    } */
}
</script>